import { endpoint } from "../../api/http"

export const mapPath = ViewPath => {
    if (ViewPath) {
        return ViewPath.replaceAll(/\[([^[^\]]*)\]/g, (match, P1)=>window.optima?.$optimaUrls ? window.optima.$optimaUrls[P1] : endpoint )
    } else return ""
}